import React, { createContext, useContext, useState, ReactNode } from "react";

interface ViewingOrgContextType {
  /** Currently selected org for "viewing" (null = All Organizations). */
  viewingOrgId: number | null;
  setViewingOrgId: (id: number | null) => void;
}

const ViewingOrgContext = createContext<ViewingOrgContextType | undefined>(undefined);

export function ViewingOrgProvider({ children }: { children: ReactNode }) {
  const [viewingOrgId, setViewingOrgId] = useState<number | null>(null);
  return (
    <ViewingOrgContext.Provider value={{ viewingOrgId, setViewingOrgId }}>
      {children}
    </ViewingOrgContext.Provider>
  );
}

export function useViewingOrg() {
  const ctx = useContext(ViewingOrgContext);
  if (ctx === undefined) {
    throw new Error("useViewingOrg must be used within ViewingOrgProvider");
  }
  return ctx;
}
